<template>
    <div class="container-fluid touch-page diary-view">
        <div class="inline100 bssystemtable">
            <div class="relative2 width80">
                <div class="header">
                    <Datepicker  :currentDate="date" @dateWasChanged="dateWasChanged($event)"></Datepicker>
                    <button type="button" @click="prev" class="btn btn-big btn-prev fleft">PREVIOUS</button>
                    <button type="button" @click="next" class="btn btn-big btn-next fleft">NEXT</button>
                    <h3 class="center">
                        <transition mode="out-in" name="fade" :duration="{ enter: 500, leave: 800 }">
                            <span v-if="showDiary">{{name}}</span>
                        </transition>
                    </h3>
                    <router-link class="btn btn-big back-home" tag="button" active-class="active" to="/">Home Page</router-link>
                </div>
            </div>
            <transition mode="out-in" name="fade" :duration="{ enter: 500, leave: 800 }">
            <table class="table booking" id="diary" v-if="showDiary">
                <thead id="sticky-anchor">
                <tr class="sticky">
                    <td class="position grey">Time/Rink</td>
                    <td v-for="t in maxRinks" :class="'rink'+t" class="rink grey">{{t}}</td>
                </tr>
                </thead>
                <tbody>
                <tr class="border" v-for="(session,index) in data">
                    <td class="grey tid"><span v-html="sessions[index]"></span></td>
                    <td v-for="rink in session" class="vtop relative rinkbt rinkbt">
                        <table class="smallrow">
                            <tr class="ringtitle" :style="{backgroundColor: '#'+rink.background}">
                                <td>{{rink.title}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name1}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name2}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name3}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name4}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name5}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name6}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name7}}</td>
                            </tr>
                            <tr>
                                <td>{{rink.name8}}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
                <div v-else>
                    <div class="loader" id="loader-1"></div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Datepicker from './Datepicker'
    export default {
        data() {
            return {
                name: null,
                date: null,
                data: null,
                sessions: null,
                maxRinks: null,
                nextDate: null,
                prevDate: null,
                showDiary: false
            }
        },
        created() {
            this.setCurrentDate();
            this.getData(this.date);
        },
        components:{
            Datepicker
        },
        methods: {
            next(){
                this.dateWasChanged(this.nextDate);
            },
            prev(){
                this.dateWasChanged(this.prevDate);
            },
            setCurrentDate(){
                var today = new Date();
                this.date = today.toISOString().substring(0, 10);
            },
            setDate(date) {
                this.date = date;
            },
            dateWasChanged(date){
                this.showDiary = false;
                this.getData(date);
            },
            getData(date) {
                axios.get('/ajax.php?q=getDiary&date=' + date)
                    .then(res => {
                        this.name = res.data.name;
                        this.data = res.data.slots;
                        this.sessions = res.data.sessions;
                        this.maxRinks = res.data.maxRinks;
                        this.nextDate = res.data.nextDate;
                        this.prevDate = res.data.prevDate;
                        this.showDiary=true;
                    })
                    .catch(error => console.log(error))
            }
        }
    }
</script>
<style scoped>
    .header{
        display: flex;
        justify-content:space-between;
    }
    .booking{z-index: 0}
    .relative2{position: relative}
    h3{
        font-size: 30px;
        line-height: 70px;
        font-weight: bold;
    }
    button.btn-big{
        margin-right: 0;
    }
    button.btn-big.btn-prev{
        margin-right: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Diary/Diary.vue